import { AxiosResponse } from "axios";
import RateioRelatorioCentroCusto from "../../../Models/Financeiro/Titulo/Rateio/RateioRelatorioCentroCusto";
import RequestUtilitario, { BasicQueryType, QueryBasicaParam } from "../../../Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../Axios";
import Rateio from "../../../Models/Financeiro/Titulo/Rateio";
import RateioFluxoRelatorio from "../../../Models/Financeiro/Titulo/Rateio/RateioFluxoRelatorio";

export function useBuscarRelatorioCentroCusto({
    codCentroCusto,
    ...rest
}:BasicQueryType<AxiosResponse<RateioRelatorioCentroCusto>, {
    codCentroCusto:number
}>) {
    return useQuery({
        queryKey : ["Financeiro.TItulo.Rateio.CentroCusto", `Financeiro.TItulo.Rateio.CentroCusto.${codCentroCusto}`],
        queryFn : () => Axios.get<RateioRelatorioCentroCusto>(`financeiro/titulo/Rateio/relatorio/centroCusto/${codCentroCusto}`),
        select : ({data}) => data,
        staleTime : 1000 * 60 * 0.08
    });
}
export function useListarComProporcionalCalculdo({
    codCentroCusto,
    ...rest
}:BasicQueryType<AxiosResponse<Rateio[]>, {
    codCentroCusto:number
}>) {
    return useQuery({
        queryKey : ["Financeiro.TItulo.Rateio.ProporcionalCalculado.CentroCusto", `Financeiro.TItulo.Rateio.ProporcionalCalculado.CentroCusto.${codCentroCusto}`],
        queryFn : () => Axios.get<Rateio[]>(`financeiro/titulo/Rateio/proporcionalCalculado/centroCusto/${codCentroCusto}`),
        select : ({data}) => data,
        staleTime : 1000 * 60 * 0.08
    });
}
export function useRateioFluxoRelatorioListar({
    rateioFluxoRelatorioParam,
    onFinish,
    ...rest
}:QueryBasicaParam<AxiosResponse<RateioFluxoRelatorio[]>, RateioFluxoRelatorio[], {
    rateioFluxoRelatorioParam:RateioFluxoRelatorio,
    onFinish:() => void;
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(rateioFluxoRelatorioParam ?? {})
    });
    return useQuery({
        ...rest,
        queryKey : ["Financeiro", "Titulo", "Rateio", "FluxoRelatorio", queryString ],
        queryFn : () => Axios.get<RateioFluxoRelatorio[]>(`financeiro/titulo/rateio/relatorio/fluxo?${queryString}`).finally(() => onFinish?.()),
        select : ({data}) => data,
        staleTime : 1000 * 60 * 0.08
    });
}
export default {
    useBuscarRelatorioCentroCusto,
    useListarComProporcionalCalculdo,
    useRateioFluxoRelatorioListar
}